import { memo } from 'react';

import { Tooltip } from 'ui-components/components/tooltip';

import { calculateOffSetOnDragStart } from '../use-on-drop';
import styles from './styles.module.less';

import type { Config } from '../config';

type WidgetPickerProps = {
  config: Config;
};

const Picker = ({ config }: WidgetPickerProps) => {
  return (
    <section className={styles['widget-picker']}>
      <ul className={styles['widget-list']}>
        {Object.values(config.widgets)
          .filter(({ definition }) => {
            if (definition.ui.isBuiltInTemplate) {
              return false;
            }

            if (!definition.ui.label || !definition.ui.pickerElement) {
              throw new Error(`Widget ${definition.type} is missing a label or pickerElement definition.`);
            }

            return true;
          })
          .map(({ definition }) => {
            return (
              <Tooltip key={definition.type} position='top' text={definition.ui.label}>
                <li
                  className={styles['widget-element']}
                  draggable
                  onDragStart={(e) => {
                    const { ui, ...widget } = definition;

                    const offSet = calculateOffSetOnDragStart(e);

                    const data = {
                      widget: { type: widget.type, ...widget.initialConfiguration },
                      dragProperties: {
                        ...offSet,
                        isNew: true,
                      },
                    };

                    e.dataTransfer.setData('application/json', JSON.stringify(data));
                  }}
                >
                  <div className={styles['widget-icon']}>{definition.ui.pickerElement}</div>
                </li>
              </Tooltip>
            );
          })}
      </ul>
    </section>
  );
};

export const WidgetPicker = memo(Picker);
